import React from 'react'
import { CleanLink } from '@components/gassan-ui/Link/CleanLink'
import { cn } from '@lib/cn'

type LogoLinkProps = {
  href: string
  imageSrc: string
  alt?: string
}

const LogoLink: React.FC<LogoLinkProps> = ({ href, imageSrc, alt }) => (
  <CleanLink
    href={href}
    className="flex rounded outline-none focus:outline-none focus:ring-2 focus:ring-rolexOceanGreen"
    aria-label={alt ?? 'Rolex logo - Go to homepage'}
  >
    <img
      className={cn('m-0 h-[50px] w-[100px]', 'md:h-[60px] md:w-[120px]')}
      src={imageSrc}
      alt={alt ?? 'Rolex logo'}
    />
  </CleanLink>
)

export default LogoLink
